export default __webpack_public_path__ + "static/media/Clinical.4fdcff0b.svg";